<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="flex w-full items-center p-4 pl-6 bg-white h-16">
      <!-- Logo -->
      <div class="flex items-center justify-center">
        <img class="h-10" src="images/logo/logo.png" />
      </div>
      <!-- Components -->
      <div class="ml-auto flex items-center">
        <!-- <notifications></notifications> -->
        <user [showAvatar]="false"></user>
      </div>
    </div>
    <!-- User -->
    <div class="flex w-full flex-col items-center p-4">
      <div class="mt-6 flex w-full flex-col items-center justify-center mb-3">
        <div
          class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal"
        >
          {{ user?.name }}
        </div>
        <div
          class="text-secondary mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center text-md font-medium leading-normal"
        >
          {{ user?.email }}
        </div>

        @if (roleName) {
          <div
            class="text-secondary mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center text-xs md:text-sm lg:text-sm xl:text-base font-medium leading-tight"
          >
            Role: {{ roleName }}
          </div>
        }
      </div>

      <div class="relative h-24 w-24 bg-white rounded-full">
        @if (companyLogo) {
          <img
            class="h-full w-full rounded-full"
            [src]="companyLogo"
            alt="User avatar"
          />
        }
        @if (!companyLogo) {
          <!-- <img
            class="h-full w-full rounded-full transform scale-90"
            src="images/logo/taj.jpeg"
            alt="User avatar"
          /> -->
          <img
            class="h-full w-full rounded-full transform scale-90"
            src="images/logo/logo-circle.svg"
            alt="User avatar"
          />
        }
      </div>
    </div>
  </ng-container>
  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationFooter>
    <div class="flex flex-col items-center px-4 py-3 border-t border-gray-700 bg-[#2d313e]">
      <p class="text-gray-400 text-xs mb-1">Need help? Reach out to us</p>
      <div class="flex items-center gap-2 text-sm">
        <mat-icon class="!w-4 !h-4 !text-base text-gray-400"
          >mail_outline</mat-icon
        >
        <a
          href="mailto:support@empliance.in"
          class="text-gray-300 hover:text-white transition-colors"
        >
          support&#64;empliance.in
        </a>
      </div>
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="bg-card fixed z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
  >
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>
    <!-- Components -->
    <div
      class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2"
      [ngClass]="{
        'mr-[280px]': !isScreenSmall && navigationOpened,
        'mr-0': isScreenSmall || !navigationOpened,
      }"
    >
      <!-- <languages></languages> -->

      <!-- <img
        class="w-9 dark:hidden cursor-pointer"
        src="images/logo/ihcl.png"
        alt="Logo image"
      /> -->
      
      <search [appearance]="'bar'"></search>
      <!-- <notifications></notifications> -->

      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
      <button mat-icon-button [matMenuTriggerFor]="userActions">
        <span class="relative">
          @if (showAvatar && user?.avatar) {
            <img class="h-7 w-7 rounded-full" [src]="user?.avatar" />
          }
          @if (!showAvatar || !user?.avatar) {
            <mat-icon
              class="mt-1"
              [svgIcon]="'heroicons_outline:user-circle'"
            ></mat-icon>
          }
          <span
            class="absolute bottom-0 right-0 h-2 w-2 rounded-full"
            [ngClass]="{
              'mb-px mr-px': !showAvatar || !user?.avatar,
              'bg-green-500': user?.status === 'online',
              'bg-amber-500': user?.status === 'away',
              'bg-red-500': user?.status === 'busy',
              'bg-gray-400': user?.status === 'not-visible',
            }"
          ></span>
        </span>
      </button>
      <mat-menu [xPosition]="'before'" #userActions="matMenu">
        <button mat-menu-item>
          <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{ user?.email }}</span>
          </span>
        </button>
        <mat-divider class="my-2"></mat-divider>

        <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item (click)="signOut()">
          <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
          ></mat-icon>
          <span>Sign out</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col mt-14">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->
</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat"></quick-chat>
